import React from '../../../../_snowpack/pkg/react.js';
import PropTypes from '../../../../_snowpack/pkg/prop-types.js';
import styled from '../../../../_snowpack/pkg/styled-components.js';
import DayPicker from '../../../../_snowpack/pkg/react-day-picker.js';
import DatePickerNavBar from './date-picker-navbar.js';
const Wrapper = styled.div.withConfig({
  displayName: "date-picker__Wrapper",
  componentId: "sc-1lcvmis-0"
})(["display:flex;justify-content:center;background:", ";border-radius:4px;box-shadow:0px 2px 4px rgba(130,138,144,0.15);padding:20px 13px;"], ({
  theme
}) => theme.colors.white);
export function DatePicker(props) {
  const {
    numberOfMonths,
    onDaySelected,
    selectedDate
  } = props;

  const handleDateChange = newDate => {
    const isSameDay = DayPicker.DateUtils.isSameDay(newDate, new Date(selectedDate)); // return a date string with toISOString();

    const value = isSameDay ? null : newDate.toISOString();
    return onDaySelected === null || onDaySelected === void 0 ? void 0 : onDaySelected(value);
  }; // place the initial month in the middle


  let initialMonth = selectedDate ? new Date(selectedDate) : new Date();
  initialMonth.setMonth(initialMonth.getMonth() - 1);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(DayPicker, {
    firstDayOfWeek: 1,
    initialMonth: initialMonth,
    navbarElement: /*#__PURE__*/React.createElement(DatePickerNavBar, null),
    numberOfMonths: numberOfMonths,
    onDayClick: handleDateChange,
    selectedDays: selectedDate ? new Date(selectedDate) : null
  }));
}
DatePicker.defaultProps = {
  numberOfMonths: 3
};
DatePicker.propTypes = {
  /**
   * Number of months to display. Default is 3
   */
  numberOfMonths: PropTypes.number,

  /**
   * Function that returns the selected date
   * @return {string} date ISO
   */
  onDaySelected: PropTypes.func.isRequired,

  /**
   * Selected date
   */
  selectedDate: PropTypes.string
};